import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const generateRuleFromText = api(async function generateRuleFromText({ text, availableFields, skillMapId }) {
    return mutate(
        gql`
            mutation GenerateRuleFromText($text: String!, $availableFields: [String], $skillMapId: String) {
                generateRuleFromText(text: $text, availableFields: $availableFields, skillMapId: $skillMapId)
            }
        `,
        { text, availableFields, skillMapId },
        { returns: "generateRuleFromText" }
    )
})
